export default __webpack_public_path__ + "static/media/CL11.2.b2e85896.mp3";